import * as yup from "yup";

export default yup
  .string()
  .matches(/^[0-9]*$/i, "Invalid Mobile Number")
  .max(9, "Invalid Mobile Number");
